var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import { Box, FormHelperText, Grid, IconButton, Switch, Typography, useTheme } from '@mui/material';
import * as pdfJs from 'pdfjs-dist';
import { useEffect, useState } from 'react';
import { FileUploader } from 'react-drag-drop-files';
import { X } from 'react-feather';
import { FileErrorType } from '../../../application/common/enums/file-error-type';
import useTranslate from '../../../localization/helpers';
import PublicPrivateToggle from '../PublicPrivateToggle';
pdfJs.GlobalWorkerOptions.workerSrc = "https://unpkg.com/pdfjs-dist@".concat(pdfJs.version, "/build/pdf.worker.min.mjs");
export var MultipleFileUpload = function (_a) {
    var onChange = _a.onChange, onValidationError = _a.onValidationError, allowedFileSize = _a.allowedFileSize, allowedTotalFileSize = _a.allowedTotalFileSize, allowedFileTypes = _a.allowedFileTypes, allowedFileTypesText = _a.allowedFileTypesText, uploadLabel = _a.uploadLabel, error = _a.error, infoText = _a.infoText, _b = _a.showPublicPrivateToggle, showPublicPrivateToggle = _b === void 0 ? false : _b, _c = _a.fileVisibility, fileVisibility = _c === void 0 ? {} : _c, onFileVisibilityChange = _a.onFileVisibilityChange, files = _a.files, _d = _a.defaultIsPublic, defaultIsPublic = _d === void 0 ? true : _d;
    var theme = useTheme();
    var _e = useTranslate(), translate = _e.translate, tWithField = _e.tWithField;
    var _f = __read(useState([]), 2), uploadedFiles = _f[0], setUploadedFiles = _f[1];
    var _g = __read(useState(''), 2), errorText = _g[0], setErrorText = _g[1];
    var _h = __read(useState(true), 2), canUpload = _h[0], setCanUpload = _h[1];
    useEffect(function () {
        if (error)
            setErrorText(error);
        else
            setErrorText('');
    }, [error]);
    // Sync uploadedFiles with external files prop
    useEffect(function () {
        if (files) {
            setUploadedFiles(files);
        }
    }, [files]);
    useEffect(function () {
        if (uploadedFiles.length > 0) {
            // Check if ANY individual file exceeds the size limit
            var hasOversizedFile = uploadedFiles.map(function (x) { return x.file; }).some(checkFileSize);
            if (hasOversizedFile) {
                onValidationError(true, FileErrorType.SizeError);
            }
            else if (checkTotalFileSize(uploadedFiles.map(function (x) { return x.file; }))) {
                // Check if total size exceeds limit
                onValidationError(true, FileErrorType.TotalSizeError);
            }
            else {
                // No errors
                onValidationError(false, FileErrorType.NoError);
            }
        }
        else {
            // Clear error when no files are present
            onValidationError(false, FileErrorType.NoError);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uploadedFiles]);
    var isFileAlreadyUploaded = function (file) {
        return uploadedFiles.some(function (uploadedFile) { return uploadedFile.file.name === file.name; });
    };
    var checkFileSize = function (file) {
        return allowedFileSize && file.size / 1024 / 1024 > allowedFileSize;
    };
    var checkTotalFileSize = function (files) {
        var totalSize = files.reduce(function (acc, file) { return acc + file.size; }, 0);
        return allowedTotalFileSize && totalSize / 1024 / 1024 > allowedTotalFileSize;
    };
    var fileTypeError = function () {
        setErrorText(translate('fileUpload.fileTypeError', {
            field: allowedFileTypesText
        }));
        onValidationError(true, FileErrorType.TypeError);
        setCanUpload(true);
    };
    var validatePDF = function (file) { return __awaiter(void 0, void 0, void 0, function () {
        var arrayBuffer, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, file.arrayBuffer()];
                case 1:
                    arrayBuffer = _b.sent();
                    return [4 /*yield*/, pdfJs.getDocument({ data: arrayBuffer }).promise];
                case 2:
                    _b.sent();
                    return [2 /*return*/, true];
                case 3:
                    _a = _b.sent();
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleFileChange = function (files) { return __awaiter(void 0, void 0, void 0, function () {
        var filesArray, newFiles, validFiles, corruptedFileNames, newFiles_1, newFiles_1_1, file, isValid, isPublic, e_1_1, errorMessage, updatedFiles;
        var e_1, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    filesArray = [];
                    if (files instanceof FileList) {
                        filesArray = Array.from(files);
                    }
                    else if (Array.isArray(files)) {
                        filesArray = files;
                    }
                    else {
                        filesArray = [files];
                    }
                    newFiles = filesArray.filter(function (file) { return (file === null || file === void 0 ? void 0 : file.name) && !isFileAlreadyUploaded(file); });
                    validFiles = [];
                    corruptedFileNames = [];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 7, 8, 9]);
                    newFiles_1 = __values(newFiles), newFiles_1_1 = newFiles_1.next();
                    _c.label = 2;
                case 2:
                    if (!!newFiles_1_1.done) return [3 /*break*/, 6];
                    file = newFiles_1_1.value;
                    if (!(allowedFileTypes === null || allowedFileTypes === void 0 ? void 0 : allowedFileTypes.includes('PDF'))) return [3 /*break*/, 4];
                    return [4 /*yield*/, validatePDF(file)];
                case 3:
                    isValid = _c.sent();
                    if (!isValid) {
                        corruptedFileNames.push(file.name);
                        return [3 /*break*/, 5]; // Skip this file but continue processing others
                    }
                    _c.label = 4;
                case 4:
                    isPublic = (_b = fileVisibility[file.name]) !== null && _b !== void 0 ? _b : defaultIsPublic;
                    validFiles.push({
                        file: file,
                        isDownloadable: false,
                        isPublic: isPublic
                    });
                    _c.label = 5;
                case 5:
                    newFiles_1_1 = newFiles_1.next();
                    return [3 /*break*/, 2];
                case 6: return [3 /*break*/, 9];
                case 7:
                    e_1_1 = _c.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 9];
                case 8:
                    try {
                        if (newFiles_1_1 && !newFiles_1_1.done && (_a = newFiles_1.return)) _a.call(newFiles_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 9:
                    // If there are corrupted files, show error
                    if (corruptedFileNames.length > 0) {
                        errorMessage = corruptedFileNames.length === 1
                            ? tWithField('fileUpload.corruptedFileError', corruptedFileNames[0])
                            : "".concat(translate('fileUpload.corruptedFilesError'), ": ").concat(corruptedFileNames.join(', '));
                        setErrorText(errorMessage);
                        onValidationError(true, FileErrorType.CorruptedError);
                        setCanUpload(true);
                    }
                    else {
                        // No errors
                        onValidationError(false, FileErrorType.NoError);
                        setErrorText('');
                    }
                    // Upload valid files even if some were corrupted
                    if (validFiles.length > 0) {
                        updatedFiles = __spreadArray(__spreadArray([], __read(uploadedFiles), false), __read(validFiles), false);
                        setUploadedFiles(updatedFiles);
                        onChange(updatedFiles);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleRemoveFile = function (fileName) {
        var updatedFiles = uploadedFiles.filter(function (fileData) { return fileData.file.name !== fileName; });
        setUploadedFiles(updatedFiles);
        setCanUpload(true);
        onChange(updatedFiles);
    };
    var handleDownloadable = function (fileName, isDownloadable) {
        var updatedFiles = uploadedFiles.map(function (fileData) {
            return fileData.file.name === fileName ? __assign(__assign({}, fileData), { isDownloadable: isDownloadable }) : fileData;
        });
        setUploadedFiles(updatedFiles);
        setCanUpload(true);
        onChange(updatedFiles);
    };
    var handleVisibilityChange = function (fileName, isPublic) {
        var updatedFiles = uploadedFiles.map(function (fileData) {
            return fileData.file.name === fileName ? __assign(__assign({}, fileData), { isPublic: isPublic }) : fileData;
        });
        setUploadedFiles(updatedFiles);
        onChange(updatedFiles);
        if (onFileVisibilityChange) {
            onFileVisibilityChange(fileName, isPublic);
        }
    };
    var calculateFileSize = function (fileSize) {
        var sizeInKB = fileSize / 1024;
        var sizeInMB = sizeInKB / 1024;
        if (sizeInMB >= 1) {
            return "".concat(sizeInMB.toFixed(2), " MB");
        }
        else {
            return "".concat(sizeInKB.toFixed(2), " KB");
        }
    };
    return (_jsxs(Grid, { size: { xs: 12 }, children: [_jsx(Box, { sx: {
                    flexDirection: { xs: 'column', md: 'row' }
                }, children: _jsxs(Box, { display: 'flex', flexDirection: 'column', justifyContent: 'center', borderRadius: '12px', gap: 0.5, padding: uploadedFiles.length > 0 ? '20px 4px 4px 4px' : theme.spacing(2.5), sx: {
                        backgroundColor: '#919EAB14',
                        height: '100%',
                        width: '100%',
                        border: '1px dashed rgba(145, 158, 171, 0.20)'
                    }, children: [_jsx(FileUploader, { multiple: true, handleChange: handleFileChange, types: allowedFileTypes, disabled: !canUpload, required: true, onTypeError: fileTypeError, children: _jsxs(Box, { display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 0.5, sx: { cursor: 'pointer' }, children: [_jsx(Icon, { icon: 'eva:cloud-upload-fill', width: '40px', height: '40px`', color: theme.palette.text.disabled }), _jsx(Typography, { variant: 'body2', color: '#919EAB', style: { wordBreak: 'break-all' }, children: uploadLabel })] }) }), uploadedFiles.length > 0 && (_jsx(Box, { display: 'flex', flexDirection: 'column', gap: 0.5, maxHeight: '160px', overflow: 'auto', children: uploadedFiles.map(function (fileData) { return (_jsxs(Box, { sx: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    borderRadius: '12px',
                                    backgroundColor: theme.palette.background.paper,
                                    padding: '4px 8px',
                                    gap: '4px'
                                }, children: [_jsxs(Box, { width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', children: [_jsxs(Box, { children: [_jsx(Switch, { size: 'small', checked: fileData.isDownloadable, onClick: function () {
                                                            return handleDownloadable(fileData.file.name, !fileData.isDownloadable);
                                                        } }), _jsx(Typography, { variant: 'caption', color: '#161C24', children: translate('fileUpload.downloadable') })] }), _jsx(Box, { sx: {
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    borderRadius: 1
                                                }, children: _jsx(IconButton, { onClick: function () { return handleRemoveFile(fileData.file.name); }, sx: { color: 'red' }, children: _jsx(X, { size: 20, color: 'red' }) }) })] }), _jsxs(Box, { display: 'flex', flexDirection: 'column', children: [_jsx(Typography, { variant: 'caption', color: theme.palette.text.primary, fontWeight: 600, style: {
                                                    wordBreak: 'break-all',
                                                    whiteSpace: 'nowrap',
                                                    textOverflow: 'ellipsis',
                                                    overflow: 'hidden'
                                                }, children: fileData.file.name }), _jsxs(Typography, { variant: 'caption', color: theme.palette.text.tertiary, whiteSpace: 'nowrap', style: { wordBreak: 'break-all' }, children: ["(", calculateFileSize(fileData.file.size), ")"] })] }), _jsx(Box, { sx: {
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: showPublicPrivateToggle ? 1 : 0
                                        }, children: showPublicPrivateToggle && (_jsx(PublicPrivateToggle, { value: fileData.isPublic ? 'Public' : 'Private', onChange: function (newValue) {
                                                handleVisibilityChange(fileData.file.name, newValue === 'Public');
                                            }, variant: 'primary', size: 'small', firstLabel: translate('documents.public'), secondLabel: translate('documents.private') })) })] }, fileData.file.name)); }) }))] }) }), infoText && (_jsx(FormHelperText, { sx: { display: 'flex', justifyContent: 'center', textAlign: 'center' }, children: infoText })), errorText && _jsx(FormHelperText, { error: true, children: errorText })] }));
};
export default MultipleFileUpload;
